<template>
  <div class="discount-tag" :style="style">
    <i v-if="iconType" class="icon_pay" :class="iconType"></i>
    <span>{{ tag.content }}</span>
  </div>
</template>

<script>
import { iconByRf } from '@/utils/tools';
export default {
  name: 'ShopDiscountTag',
  props: {
    tag: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    style() {
      let { backColor, fontColor } = this.tag;
      let style = {};
      backColor && (style['background-color'] = backColor);
      fontColor && (style['color'] = fontColor);
      return style;
    },
    iconType() {
      const text = this.tag?.icon;
      return iconByRf(text);
    },
  },
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.discount-tag {
  display: flex;
  padding: rem(6) rem(16);
  height: rem(42);
  line-height: rem(30);
  font-size: rem(24);
  font-family: DiDiSans-Pro-Regular;
  color: #ff8040;
  font-weight: 400;
  background: rgba(255, 128, 64, 0.1);
  border-radius: rem(12);
  align-items: center;

  .icon_pay {
    font-size: rem(24);
    vertical-align: middle;
    margin-right: rem(8);
  }
}
</style>
